var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"20","fill":"black","key":0}),React.createElement("path",{"d":"M25.532 20.3119L17.583 25.6112C17.4107 25.7261 17.1779 25.6795 17.063 25.5072C17.0219 25.4456 17 25.3732 17 25.2992V14.7006C17 14.4935 17.1679 14.3256 17.375 14.3256C17.449 14.3256 17.5214 14.3475 17.583 14.3885L25.532 19.6879C25.7043 19.8028 25.7509 20.0356 25.636 20.2079C25.6085 20.2491 25.5732 20.2844 25.532 20.3119Z","fill":"#FFCC00","key":1})]);
}

PlayButton.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
